export default "__VITE_ASSET__f8711bf4__"